var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInviteGuests(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.3125 4.53125C1.3125 2.4781 2.9781 0.8125 5.03125 0.8125C7.0844 0.8125 8.75 2.4781 8.75 4.53125C8.75 5.89784 8.01209 7.09273 6.91314 7.73905C8.35988 8.32327 9.47328 9.56085 9.88726 11.0857C10.2126 8.62168 12.3224 6.71875 14.875 6.71875C17.6528 6.71875 19.9063 8.97224 19.9063 11.75C19.9063 14.5278 17.6528 16.7813 14.875 16.7813C12.3197 16.7813 10.208 14.8742 9.8862 12.4063H9.1875C9.1875 10.1117 7.32576 8.25 5.03125 8.25C2.73674 8.25 0.875 10.1117 0.875 12.4063H0C0 10.2938 1.30331 8.48453 3.14936 7.73905C2.05041 7.09273 1.3125 5.89784 1.3125 4.53125ZM5.03125 1.6875C3.46135 1.6875 2.1875 2.96135 2.1875 4.53125C2.1875 6.10115 3.46135 7.375 5.03125 7.375C6.60115 7.375 7.875 6.10115 7.875 4.53125C7.875 2.96135 6.60115 1.6875 5.03125 1.6875ZM14.875 7.59375C12.5805 7.59375 10.7188 9.45549 10.7188 11.75C10.7188 14.0445 12.5805 15.9063 14.875 15.9063C17.1695 15.9063 19.0313 14.0445 19.0313 11.75C19.0313 9.45549 17.1695 7.59375 14.875 7.59375Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3125 12.1875V14.375H14.4375V12.1875H12.25V11.3125H14.4375V9.125H15.3125V11.3125H17.5V12.1875H15.3125Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteGuests);
export default __webpack_public_path__ + "static/media/InviteGuests.dce2682a2b474bef0a74a43b99309fd3.svg";
export { ForwardRef as ReactComponent };